module.exports = __webpack_public_path__ + "img/instagram.0634a5ba.png";